import { render, staticRenderFns } from "./CardMobileExpert.vue?vue&type=template&id=6f20936b&scoped=true&"
import script from "./CardMobileExpert.vue?vue&type=script&lang=js&"
export * from "./CardMobileExpert.vue?vue&type=script&lang=js&"
import style0 from "./CardMobileExpert.vue?vue&type=style&index=0&id=6f20936b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20936b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
